module.exports = __webpack_public_path__ + "img/equivalent_icon.14670ac4.svg";